module.exports = __webpack_public_path__ + "img/blacklist.3b663102.svg";